module.exports = "/packs/images/homepage/facilities/man_with_tablet~fffdfafc3b1fef394b2e42994fdeddce.png";